// @flow
import "./style/lowes.css";
import React from "react";
import withClientPage from "../../hoc/withClientPage";
import withTemplate from "../../hoc/templates/withTemplate";
import withBasic from "../../hoc/templates/withBasic";

const PassedProps = {
  clientBodyClassNames: "container-fluid lowes-main",
  clientContentClassNames: "col-12 col-md-6",
  headingText: "",
  buttonClassNames: "btn btn-secondary mt-2 check-balance-button",
  cardInputLabel: "Card Number *",
  cardInputPlaceholder: "Card Number",
  pinInputLabel: "PIN *",
  pinInputPlaceholder: "PIN",
  labelClassNames: "font-weight-bold text-body",
  showEnhancedResults: false,
  showCardEOV: false,
  justifyContent: "start",
  buttonText: "CHECK BALANCE",
  labelAnimation: false,
  resultsClassNames: "light-grey-text",
};

const clientPageProps = {
  title: "lowes.title",
  favicon: "/lowes.ico",
  errorMsg: "lowes.error",
  callTranslations: PassedProps.showEnhancedResults
};

const LOWEB = () => (
  <React.Fragment>
    <div className="requiredField">
      <p>* Indicates a required field</p>
    </div>
  </React.Fragment>
);

export default withClientPage(withTemplate(withBasic(LOWEB), PassedProps), clientPageProps);
